<template>
  <a-result>
    <template #icon>
      <a-icon type="clock-circle" theme="twoTone" />
    </template>
    <h1 slot="title" class="pt-3">
      {{ $t('msg.office.exported.title') }}
    </h1>
    <div slot="subTitle">
      <p class="font-size-18 text-secondary pt-2 pb-3">
        {{ $t('msg.office.exported.subtitle') }}
      </p>
    </div>
    <template #extra>
      <router-link :to="`/offices`">
        <a-button
          type="primary"
          size="large">
          {{ $t('msg.office.exported.action') }}
        </a-button>
      </router-link>
    </template>
  </a-result>
</template>

<script>
export default {
  name: 'OfficeExportResult',
}
</script>
